// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__10Ltg","inner":"Form_inner__21nni","range":"Form_range__3yiAR","name":"Form_name__2_TOt","actions":"Form_actions__1Kvw3"};